<template>
  <div class="boxtitle roundedblu">
    2.Graphical User Interface
  </div>
  <div class="mx-5 mt-2">
    <el-row class="left-align mt-4 mx-3"
      ><h2 style="font-family: NotesEsaRegular;">Query Panel</h2></el-row
    >
    <hr class="divider" />
    <el-row class="f2">
      The query panel provides a visual input interface for query conditions
      such as spatial area, time selection, and satellite selection.
    </el-row>
    <el-row class="mt-3 mx-5">
      <img src="../../assets/pannel.jpg" style="max-width: 90%;" />
    </el-row>
    <el-row class="f2 left-align mt-3">
      The map tool provides a geographical search feature for defining an Area
      of Interest (AoI) either in the shape of a box or of a polygon. Users will
      be able to search on the Map Layer either in Navigation Mode or Area Mode:
      Click on one of these icons to switch from one mode to the other.
    </el-row>
    <el-row class="mt-3 mx-5">
      <img src="../../assets/panel2.jpg" style="max-width: 90%;" />
    </el-row>
    <ul class="mt-2 left-align">
      <li>
        define a rectangle area of interest (box). Click the clear button to
        remove the Aoi area
      </li>
      <el-row class="mt-3 mx-4">
        <img src="../../assets/panel3.jpg" style="max-width: 90%;" />
      </el-row>
      <li class="mt-3">
        define an area of interest enclosed in a polygon shape (polygon)
      </li>
      <el-row class="mt-3 mx-4">
        <img src="../../assets/panel4.jpg" style="max-width: 90%;" />
      </el-row>
    </ul>
    <el-row class="f2 left-align mt-3"
      >Users can also set query criteria such as satellite name, data shooting
      date, product level, and cloud cover</el-row
    >
    <div id="search result">
      <el-row class="left-align mt-4 mx-3"
        ><h2 style="font-family: NotesEsaRegular;">Search Results</h2></el-row
      >
      <hr class="divider" />
      <el-row class="f2 left-align mt-3"
        >The Search results list provides all the products matching the
        submitted search query. Each result consists of:
      </el-row>

      <ul class="mt-2 left-align">
        <li>64x64 thumbnail when available</li>
        <li>product name</li>
        <li>Date corresponding to the Sensing Start date</li>
        <li>the satellite name</li>
      </ul>
      <el-row class="f2 left-align mt-3">
        The footprints of the products matching the search query are displayed
        on the map. Each footprint gets highlighted when hovering on the
        corresponding product in the search results list. Blue footprints show
        GF-1 products.
      </el-row>
      <el-row class="f2 left-align mt-3 note"
        >NOTE: the map tool only shows the footprints of the products in the
        current search list page. To widen results modify the page size (10,25,
        50, 100).
      </el-row>
      <el-row class="mt-3 mx-4">
        <img src="../../assets/panel5.jpg" style="max-width: 90%;" />
      </el-row>
      <el-row class="mt-3 mx-4"
        >Click on &nbsp;<em style="font-weight: bold;">Show Product</em>&nbsp;
        list icon to go back to the product list.
      </el-row>
      <el-row class="mt-3 mx-4">
        <img src="../../assets/panel6.jpg" style="max-width: 90%;" />
      </el-row>
    </div>

    <div id="product" class="mt-5">
      <el-row class="left-align mt-4 mx-3"
        ><h2 style="font-family: NotesEsaRegular;">Products</h2></el-row
      >
      <hr class="divider" />
      <el-row class="mt-3 mx-4"
        >The following options are available for each product displayed in the
        search list:
      </el-row>
      <ul class="mt-2 left-align">
        <li>Zoom to product</li>
        <li>View Product Details</li>
        <li>Add product to Cart</li>
        <li>Download Product</li>
      </ul>
      <el-row class="mt-3 mx-4">
        <img src="../../assets/panel7.jpg" style="max-width: 90%;" />
      </el-row>
      <el-row class="mt-3 mx-4"
        >Click on the View Product Details icon and the following product
        information will be visualized:
      </el-row>
      <ul class="mt-2 left-align">
        <li>Product name</li>
        <li>Attributes(Summary, Product, Platform, Instrument)</li>
        <li>Full resolution quicklook</li>
      </ul>
      <el-row class="mt-3 mx-4">
        <img src="../../assets/panel8.jpg" style="max-width: 90%;" />
      </el-row>
    </div>

    <div id="profile" class="mt-4">
      <el-row class="left-align mt-4 mx-3"
        ><h2 style="font-family: NotesEsaRegular;">Profile Panel</h2></el-row
      >
      <hr class="divider" />
      <el-row class="mt-3 mx-4">Click on User Profile button to: </el-row>
      <ul class="mt-2 left-align">
        <li>See the allowed functionalities: search and download products</li>
        <li>Cart: allows to manage the product(s) added by the user</li>
      </ul>
      <el-row class="mt-3 mx-4">
        <img src="../../assets/panel9.jpg" style="max-width: 90%;" />
      </el-row>
      <el-row class="mt-3 mx-4"
        >Click on Edit Profile button to access the profile panel.
      </el-row>
      <el-row class="mt-3 mx-4">
        <img src="../../assets/panel10.jpg" style="max-width: 90%;" />
      </el-row>
      <el-row class="mt-3 mx-4"
        >The profile panel contains all the account details and the possibility
        to change the password.</el-row
      >
      <el-row class="mt-3 mx-4">
        <img src="../../assets/panel11.jpg" style="max-width: 90%;" />
      </el-row>
    </div>

    <div class="cart">
      <el-row class="left-align mt-4 mx-3"
        ><h2 style="font-family: NotesEsaRegular;">Cart Panel</h2></el-row
      >
      <hr class="divider" />
      <el-row class="mt-3 mx-4">The Open Access Hub provides a Cart that can contain a number of products.</el-row>
      <el-row class="mt-3 mx-4">he Cart can be opened either by the Search Bar </el-row>
      <el-row class="mt-3 mx-4">
        <img src="../../assets/panel12.jpg" style="max-width: 90%;" />
      </el-row>
      <el-row class="mt-3 mx-4">To add products to the Cart, start by performing a query.</el-row>
      
      <el-row class="mt-3 mx-4">click on the Add Product to Cart (Trolley) icon just below the product result</el-row>
      <el-row class="mt-3 mx-4">
        <img src="../../assets/panel13.jpg" style="max-width: 90%;" />
      </el-row>
      <el-row class="mt-3 mx-4">All products sent to the Cart will be displayed once you open/view your Cart</el-row>
      <el-row class="mt-3 mx-4">
        <img src="../../assets/panel14.jpg" style="max-width: 90%;" />
      </el-row>
    </div>

    <el-row class="right-align mt-5 mb-3">
        <el-col :span="15" :offset="6">
          <!-- 使用 offset 来实现内容居中 -->
          <div class="right-align">back to top</div>
        </el-col>
        <el-col class="mx-1"  :span="1">
          <el-button @click="scrollToTop" class="custom-icon-button" size="mini" circle 
            ><el-icon :size="20"><ArrowUp></ArrowUp></el-icon
          ></el-button>
        </el-col>
      </el-row>
  </div>
</template>


<script>
import { ArrowUp } from "@element-plus/icons";

export default {
  components: {
    ArrowUp,
  },
  setup() {
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 使用平滑滚动效果
      });
    };
    return { ArrowUp,scrollToTop };
  },
};
</script>

<style scoped>
.right-align {
  text-align: right;
  font-family: "NotesEsaRegular" !important;
}
.custom-icon-button {
  background-color: #0073e6; /* 设置按钮背景颜色为蓝色 */
  color: #fff; /* 设置文本颜色为白色 */
  border-color: #0073e6; /* 设置边框颜色为蓝色 */
}
.divider {
  color: #333;
  background-color: #333;
  height: 2px;
}
.boxtitle {
  margin: 5px !important;
  color: white !important;
  text-align: left;
}
.roundedblu {
  background: #1e364e;
  color: #fff;
  margin: 0 auto;
  margin-top: 10px;
  margin-bottom: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  font-family: "NotesEsaRegular";
  font-size: 22px;
  padding: 15px;
  overflow: auto;
}
.left-align {
  text-align: left;
  font-family: "NotesEsaRegular" !important;
}
img {
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5); /* 横向偏移，纵向偏移，模糊半径，颜色 */
}
.note {
  background: #5ea4eb;
  color: #fff;
  margin: 0 auto;
  margin-top: 10px;
  margin-bottom: 5px;

  border-radius: 5px;
  font-family: "NotesEsaRegular";
  font-size: 18px;
  padding: 15px;
  overflow: auto;
}
ul li {
  margin-bottom: 20px; /* 列表项之间的下边距 */
}
</style>
